import { lazy } from "react";
const lazyLoadWithFallback = (importFunc) => {
  return lazy(importFunc);
};
export {
  lazyLoadWithFallback
};
